export default __webpack_public_path__ + "static/media/hero.d6f90b54.jpg";